export default __webpack_public_path__ + "static/media/library.d777e65b.png";